import { Game } from "../../../Game";
import { MovingTargetController, MovingTargetPathPos, MovingTargetSettings } from "../Controllers/MovingController";
import { TargetBase } from "../Targets/Target";
import { eTrajDisMark, TrajectoryDisplayer } from "./TrajectoryDisplayer";



export class MovingTarTrajDis extends TrajectoryDisplayer {
    private _targetPathPos: MovingTargetPathPos;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        super();
        this._targetPathPos = new MovingTargetPathPos();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    show(target: TargetBase): void {
        let meshCreator = Game.planeMeshCreator;
        let controller = target.controller as MovingTargetController;
        let pathLen = controller.pathLen;
        let pathPos = 0;
        let markPos = new pc.Vec3();
        let dotMark = TrajectoryDisplayer._marks[eTrajDisMark.dot];
        let crossMark = TrajectoryDisplayer._marks[eTrajDisMark.cross];
        let pathSections = controller.pathSections;
        let pathSectionId = 0;

        this._targetPathPos.sectionId = 0;
        meshCreator.reset();

        while (pathPos < pathLen) {
            controller.getPosition(pathPos / pathLen, this._targetPathPos, this._targetPathPos.sectionId);

            if (pathSectionId != this._targetPathPos.sectionId) {
                let point1 = pathSections[pathSectionId].pointB;
                let point2 = pathSections[this._targetPathPos.sectionId].pointA;

                if (Math.abs(point1.x - point2.x) > 0.3 || Math.abs(point1.y - point2.y) > 0.3) {
                    markPos.set(point1.x, point1.y, 0.01);
                    meshCreator.addPlane(markPos, crossMark.vertexOffsets, crossMark.vertexUVs);
                }

                pathSectionId = this._targetPathPos.sectionId;
            }

            markPos.set(this._targetPathPos.pos.x, this._targetPathPos.pos.y, 0);
            meshCreator.addPlane(markPos, dotMark.vertexOffsets, dotMark.vertexUVs);

            pathPos += 0.2;
        }

        if (!(target.settings as MovingTargetSettings).moveYoyo) {
            let pos = pathSections[pathSections.length - 1].pointB;

            markPos.set(pos.x, pos.y, 0.01);
            meshCreator.addPlane(markPos, crossMark.vertexOffsets, crossMark.vertexUVs);
        }

        meshCreator.calculateNormals();
        meshCreator.initMesh(TrajectoryDisplayer._mesh);

        super.showEnd(target);
    }
}